export const CLEAR_ANSWERS = 'TASTE_PROFILE_ONBOARDING/CLEAR_ANSWERS'
export const SAVE_GENERATED_IMAGE_URLS = 'TASTE_PROFILE_ONBOARDING/SAVE_GENERATED_IMAGE_URLS'

export function clearAnswers () {
  return {
    type: CLEAR_ANSWERS
  }
}

export function saveGeneratedImageUrls (payload) {
  return {
    type: SAVE_GENERATED_IMAGE_URLS,
    payload
  }
}
